module.exports = __webpack_public_path__ + "static/media/5.23.8720a556.png";